import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { lookupGetStateOld } from 'legacy/lut/store'
import { useCallback, useEffect, useState } from 'react'

import { IDataProviderFilter } from 'core-components/types'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

const CTRY_SB_DVSN_TYP_CD = ['STATE', 'PROVINCE', 'REGION']

export const useCountryStates = (country: string, key: string = 'default') => {
  const [states, setStates] = useState<{ key: string; label: string }[]>([])
  const [statesWithLocal, setStatesWithLocal] = useState<{ key: string; label: string }[]>([])
  const [statesIsLoading, setStatesIsLoading] = useState(false)

  const fetchStates = useCallback(async () => {
    setStatesIsLoading(true)
    try {
      const countries = lookupGetStateOld().references.countries
      const foundCountry = countries.find((el: any) => el.name === country || el.value === country)
      if (foundCountry) {
        const crud = CrudStore.get(CrudStoreItem.CountryProvinceNames, `searchState-${key}`)

        crud.setFilter(prepareFilter(foundCountry.value))

        crud.setPaging({
          page: 0,
          pageSize: 150,
        })

        const rows = (await crud.fetch()).items
        const { states, statesWithLocal } = rows.reduce(
          (acc, item: any) => {
            const fieldName = item['LG_NM'] && item['LG_NM'] !== 'NULL' ? 'LG_NM' : 'NM'

            return {
              states: [
                ...acc.states,
                {
                  key: item[fieldName],
                  label: item[fieldName],
                },
              ],
              statesWithLocal: [
                ...acc.statesWithLocal,
                {
                  key: item['LOCAL_NAME'] || item[fieldName],
                  label: item['LOCAL_NAME'] || item[fieldName],
                },
              ],
            }
          },
          { states: [], statesWithLocal: [] }
        )

        setStates(states)
        setStatesWithLocal(statesWithLocal)
      }
    } catch (e) {
      setStates([])
    } finally {
      setStatesIsLoading(false)
    }
  }, [country, key])

  useEffect(() => {
    country && fetchStates()
  }, [country, fetchStates])

  return { states, statesWithLocal, statesIsLoading }
}

function prepareFilter(country: string): IDataProviderFilter {
  const typeFilter: IDataProviderFilter = {
    logic: Logic.OR,
    filters: [],
  }

  for (const type of CTRY_SB_DVSN_TYP_CD) {
    typeFilter.filters.push({
      field: 'CTRY_SB_DVSN_TYP_CD',
      operator: Operator.EQUAL,
      value: type,
    })
  }

  return {
    logic: Logic.AND,
    filters: [
      {
        field: 'CTRY_CD',
        operator: Operator.EQUAL,
        value: country,
      },
      // typeFilter,
    ],
  }
}
